export const VEX_GATEWAY_CDN_URL = process.env.VEX_GATEWAY_CDN_URL ?? '';
export const VEX_STOCK_IMAGES_CDN_URL = process.env.VEX_STOCK_IMAGES_CDN_URL ?? '';
